import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Purchase from "../../topviews/Purchase";

function UserAddons({
  watch,
  getValues,
  setValue,
  userAddons,
  existPurchased,
  existAvailable,
  addonsError,
  setaddonsError,
  clearErrors
}) {
  const { t, i18n } = useTranslation();
  // const [add, setAdd] = useState([]);
  // const [remove, setRemove] = useState([]);
  const [addonsList, setaddonsList] = useState([]);

  useEffect(() => {
    if (userAddons && userAddons.length > 0) {
      setaddonsList(userAddons);
    }
  }, [userAddons]);

  useEffect(() => {
    if (addonsError && addonsError.length > 0) {
      const errorMap = addonsError.reduce((acc, error) => {
        const [key, message] = Object.entries(error)[0];
        acc[parseInt(key, 10)] = message;
        return acc;
      }, {});

      console.log("errorMap:::::::: " + JSON.stringify(errorMap));

      // Merge errors into addOns
      const enhancedAddOns = addonsList.map((addOn) => ({
        ...addOn,
        error: errorMap[addOn.fid] || null,
      }));

      console.log("enhancedAddOns:" + JSON.stringify(enhancedAddOns));

      // Update state with the enhanced add-ons list
      setaddonsList(enhancedAddOns);
      setaddonsError([]);
    }
  }, [addonsError]);
  const handleChange = (isPurchased, fid) => {
    let speechToText = addonsList.filter(eachAddon => eachAddon.addonname === "Speech To Text");
    if(speechToText.length && fid == speechToText[0].fid){
      clearErrors("voice_mail.email_transcript");
    }
    if (isPurchased) {
      const removeList = watch("addons.removed_addons").filter(
        (id) => id !== fid
      );
      // setRemove([...removeList]);
      const purIndex = existPurchased.findIndex((purfid) => purfid === fid);
      let addTmpList = [];
      if (purIndex === -1) {
        addTmpList = [...watch("addons.added_addons"), parseInt(fid)];
        // setAdd(addTmpList);
        setValue("addons.added_addons", addTmpList, { shouldDirty: true });
      }
      setValue("addons.removed_addons", removeList, { shouldDirty: true });
    } else {
      const addList = watch("addons.added_addons").filter((id) => id !== fid);
      // setAdd([...addList]);
      const avIndex = existAvailable.findIndex((avifid) => avifid === fid);
      let removeTmpList = [];
      if (avIndex === -1) {
        removeTmpList = [...watch("addons.removed_addons"), parseInt(fid)];
        setValue("addons.removed_addons", removeTmpList, { shouldDirty: true });
      }
      setValue("addons.added_addons", addList, { shouldDirty: true });
    }
    const updatedList = addonsList.map((addon) =>
      addon.fid === fid
        ? { ...addon, purchased: isPurchased, error: null }
        : addon
    );
    setaddonsList(updatedList);
  };

  return (
    <>
      <div className="general-settings">{t("Add-Ons")}</div>

      <div className="ps-0">
        {addonsList &&
          addonsList.length > 0 &&
          addonsList
            .filter((addon) => addon.fid !== 35)
            .map((item) => (
              <div key={item.fid} className="add-numbermain">
                <div className="tel-numbers">{item.addonname}</div>
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      type="checkbox"
                      checked={item.purchased}
                      onChange={(e) => handleChange(e.target.checked, item.fid)}
                    />
                    <span className="slider round"></span>
                  </label>
                  {item.error && <p className="text-danger">{item.error}</p>}
                </div>
              </div>
            ))}
      </div>
    </>
  );
}

export default UserAddons;
